import { DocumentFormat, FormDocument } from 'epic/common-form/Documentation';
import { IntlKey } from 'locales';
import { FormattedMessage } from 'react-intl';
import { EssentialDocument } from 'routes/essential-workspace/components/quote-panel/collapse/docs-item/doc';

export function EssentialInfoDocItem({ doc, canShowError }: { doc: FormDocument; canShowError?: boolean }) {
  const hasMultipleDoc = () => {
    return (doc.items?.length ?? 0) > 1;
  };

  const groupedByLanguage = doc.items?.reduce(
    (acc, item) => {
      const existing = acc.find(g => g.language === item.language);
      if (existing) {
        existing.formats.push(item.format);
      } else {
        acc.push({ language: item.language, formats: [item.format] });
      }
      return acc;
    },
    [] as Array<{ language: string; formats: DocumentFormat[] }>,
  );

  return (
    <li className="flex-x justify-content-between list-group-item py-1 px-0 border-top">
      <div className="flex-x gap-2">
        <i className="icon icon-outlined text-secondary">{hasMultipleDoc() ? 'library_books' : 'description'}</i>
        <h6 className="fs-5 fw-medium">
          <FormattedMessage id={`form.buttons.${doc.type}Button` as IntlKey} />
        </h6>
      </div>
      <div className="flex-x gap-2">
        {groupedByLanguage?.map((item, index) => (
          <EssentialDocument
            key={`${item.language}-${index}`}
            type={doc.type}
            language={item.language}
            formats={item.formats}
            canShowError={canShowError}
          />
        ))}
      </div>
    </li>
  );
}
